module.exports = __webpack_public_path__ + "static/kaushik-d5d5d0a94d1d9cae5b8ef9d5466b6826.jpeg";